export default "__VITE_PUBLIC_ASSET__fe88b0c7__"